import React from "react";
import Header from "../Layout/Header";
import { Outlet } from "react-router-dom";
import Footer from "../Layout/Footer";
import Sidebar from "../Layout/Sidebar";
import { WinnersFooterBlue } from "../Layout/WinnersFooterBlue";

const MainLayout = () => {
  return (
    <>
      {/* <Header /> */}
      <Outlet />
      {/* <Footer /> */}
      <WinnersFooterBlue/>
    </>
  );
};

export default MainLayout;
